<template>
  <div class="text-center d-flex">
    <v-menu
      bottom
      :close-on-content-click="closeOnContentClick"
      width="300"
      offset-y
      z-index="1"
      allow-overflow
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          hide-details
          height="10"
          class="caption"
          prepend-inner-icon="mdi-filter"
          :placeholder="$_strings.order.FILTER"
          outlined
          dense
          readonly
          v-bind="attrs"
          @click="closeOnContentClick = false"
          v-on="on"
        ></v-text-field>
      </template>
      <v-list
        width="300"
        min-height="150"
        max-height="500"
        class="overflow-auto"
      >
        <section v-for="item in itemsFilterAutoComplete" :key="item.id">
          <v-list-item>
            <v-list-item-title class="caption font-weight-bold">{{item.title}}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="pt-0 mt-0">
              <common-auto-complete-items
                :type="item.type"
                :searchName="item.searchName"
                :item-value="item.value"
                :item-text="item.text"
                hide-details
                height="10"
                v-model="form[item.vModel]"
                :placeholder="item.placeholder"
                dense
                outlined
                class="caption"
                clearable
                @updateItems="item.updateItems"
                :filter="pageFilters[item.filters]"
                :items="itemsFilter[item.items]"
              />
            </v-list-item-content>
          </v-list-item>
        </section>
        <section>
          <v-list-item>
            <v-list-item-title class="caption font-weight-bold">Nomor Kendaraan</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="pt-0 mt-0">
              <v-tooltip v-model="showTooltipLicensePlate" bottom>
                <template v-slot:activator="{ }">
                  <v-text-field
                    dense
                    outlined
                    class="caption"
                    placeholder="A 1234 BC"
                    v-model="form.companyTransportNo"
                    hide-details
                    @input="handleTooltipLicensePlate"
                    @blur="showTooltipLicensePlate = false"
                  />
                </template>
                <p>Ex: A 1234 BC</p>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </section>
        <section>
          <v-list-item>
            <v-list-item-title class="caption font-weight-bold">Status</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="pt-0 mt-0">
              <section
                v-for="(chip, index) in latestStatus"
                :key="chip"
                class="mb-2"
              >
                <v-chip
                  close
                  small
                  @click:close="removeLatestStatus(index)"
                >
                  <strong>
                    {{ itemsLatestStatus.find((item) => item.value === chip) && itemsLatestStatus.find((item) => item.value === chip).text }}
                  </strong>
                </v-chip>
              </section>
              <v-autocomplete
                hide-details
                :items="itemsLatestStatus.filter((item) => !(latestStatus.find((ls) => ls === item.value)))"
                @change="addLatestStatus"
                v-model="status"
                class="caption"
                placeholder="Pilih status"
                dense
              ></v-autocomplete>
            </v-list-item-content>
          </v-list-item>
        </section>
        <section class="pl-2 pr-2">
          <v-btn
            depressed
            color="primary"
            block
            @click="setFilter"
          >
            {{$_strings.common.APPLY}}
          </v-btn>
          <v-btn
            depressed
            class="mt-2 white--text"
            color="red"
            block
            @click="closeOnContentClick = true"
          >
            {{$_strings.common.CLOSE}}
          </v-btn>
        </section>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.setItemsFromQueryString();
  },
  data() {
    return {
      status: '',
      calculated: this.$route.query.isCalculated === 'true',
      notCalculated: this.$route.query.isCalculated === 'false',
      pod: this.$route.query.isPod === 'true',
      notPod: this.$route.query.isPod === 'false',
      itemsFilterAutoComplete: [
        {
          id: 'origin',
          title: 'Lokasi Asal',
          type: 'locations',
          searchName: 'name',
          placeholder: 'Semua Lokasi Asal',
          text: 'name',
          value: 'id',
          vModel: 'originLocationId',
          items: 'itemsLocation',
          updateItems: this.updateLocation,
          filters: 'location',
        },
        {
          id: 'destination',
          title: 'Lokasi Tujuan',
          type: 'locations',
          searchName: 'name',
          placeholder: 'Semua Lokasi Tujuan',
          text: 'name',
          value: 'id',
          vModel: 'destinationLocationId',
          items: 'itemsLocation',
          updateItems: this.updateLocation,
          filters: 'location',
        },
      ],
      itemsLatestStatus: [
        ...this.$_strings.order.STATUS_LIST_WAITING,
        ...this.$_strings.order.STATUS_LIST_PROCESS,
        ...this.$_strings.order.STATUS_LIST_COMPLETED,
      ],
      form: {
        originLocationId: +this.$route.query.originLocationId || '',
        destinationLocationId: +this.$route.query.destinationLocationId || '',
        companyTransportNo: this.$route.query.companyTransportNo || '',
      },
      itemsFilter: {
        itemsLocation: [],
      },
      pageFilters: {
        location: {
          search: '',
          page: 0,
          size: 25,
          totalData: 0,
        },
      },
      closeOnContentClick: false,
      latestStatus: this.$route.query.latestStatus ? this.$route.query.latestStatus.split(',') : [],
      showTooltipLicensePlate: false,
    };
  },
  methods: {
    handleTooltipLicensePlate(value) {
      const pattern = /^([A-Za-z]{1,4})([\s]{1})([0-9]{1,5})([\s]{1})([A-Za-z]{0,3})$/;
      if (!pattern.test(value) && value) {
        this.showTooltipLicensePlate = true;
        return;
      }
      this.showTooltipLicensePlate = false;
    },
    setItemsFromQueryString() {
      const {
        originLocationId,
        origin,
        destinationLocationId,
        destination,
      } = this.$route.query;
      if (originLocationId) {
        this.itemsFilter.itemsLocation.push({
          id: +originLocationId,
          name: origin,
        });
      }
      if (destinationLocationId) {
        this.itemsFilter.itemsLocation.push({
          id: +destinationLocationId,
          name: destination,
        });
      }
    },
    updateLocation(items) {
      this.itemsFilter.itemsLocation = [...this.itemsFilter.itemsLocation, ...items];
    },
    addLatestStatus(value) {
      this.latestStatus.push(value);
    },
    removeLatestStatus(index) {
      this.latestStatus.splice(index, 1);
      this.status = '';
    },
    setFilter() {
      this.closeOnContentClick = true;
      const {
        originLocationId,
        destinationLocationId,
        companyTransportNo,
      } = this.form;
      const oldFilters = { ...this.filters };
      this.filters.originLocationId = originLocationId;
      this.filters.destinationLocationId = destinationLocationId;
      this.filters.companyTransportNo = companyTransportNo;
      this.filters.latestStatus = this.latestStatus.toString();
      if (JSON.stringify(oldFilters) !== JSON.stringify(this.filters)) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            ...this.filters,
            origin: originLocationId ? this.itemsFilter.itemsLocation.find((item) => item.id === +originLocationId).name : '',
            destination: destinationLocationId ? this.itemsFilter.itemsLocation.find((item) => item.id === +destinationLocationId).name : '',
          },
        });
      }
      this.$emit('applyFilters');
    },
  },
};
</script>
